import React, { useContext, useEffect, useState } from 'react';
import { INSTANCE_WHITE_LOGO_URL as logo } from '../../components/ui/InstanceLogo';
import './policity.css';



const PolicityPage = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [logoUrl, setLogoUrl] = useState<string | null>(null);



    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false)
        }, 1000);
    }, []);

    useEffect(() => {

        const company = process.env.REACT_APP_COMPANY;
        let url = logo;



        setLogoUrl(url);
    }, []);



    return (
        <div>
            {
                isLoading ?
                    (
                        <div className="d-flex justify-content-center">
                            <div className="spinner-border  text-info mt-5" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    )
                    :
                    (

                        <div className={`wrapper ${isLoading ? 'fadeInDown' : ''} `} >
                            <div id='header' className='headerLogin'>
                                <img src={logoUrl} alt='Logo' className='logo'></img>
                            </div>
                            <div id='policityContent' >
                                <div>

                                    <h4 className='mb-2' style={{ textAlign: 'center' }}>POL&Iacute;TICA DE PRIVACIDAD Y PROTECCI&Oacute;N </h4>
                                    <h4 className='mb-2' style={{ textAlign: 'center' }}>DE DATOS &ndash; SWIFTPAY&reg;</h4>

                                    <p style={{ marginTop: '5%', marginBottom: '8pt', }}>
                                        SWIFTPAY S.A., una sociedad costarricense inscrita en la Secci&oacute;n Mercantil del Registro P&uacute;blico bajo la c&eacute;dula jur&iacute;dica <strong>3-101-889631</strong>, con domicilio en <strong>San Jos&eacute;, Costa Rica</strong>, es titular de la marca <strong>SWIFTPAY&reg;</strong>, plataforma tecnol&oacute;gica que provee servicios de <strong>procesamiento de pagos electr&oacute;nicos, facturaci&oacute;n digital, links de pago, terminales POS, Tap on Phone, programas de lealtad, pagos recurrentes y otros servicios financieros digitales</strong>.
                                    </p>
                                    <p style={{ marginTop: 0, marginBottom: '8pt' }}>
                                        SWIFTPAY&reg; es una empresa comprometida con la <strong>seguridad, confidencialidad y transparencia en el tratamiento de los datos personales</strong> de sus usuarios, comercios afiliados y consumidores finales. Al utilizar nuestros servicios, ya sea a trav&eacute;s de nuestras aplicaciones m&oacute;viles, sitio web o interfaces de integraci&oacute;n (API), usted <strong>acepta los t&eacute;rminos y condiciones</strong> de esta Pol&iacute;tica de Privacidad.
                                    </p>

                                    <p style={{ marginTop: 0, marginBottom: '8pt' }}>&nbsp;</p>

                                    <p style={{ marginTop: 0, marginBottom: '8pt', fontWeight: 'bold' }}>
                                        1. Recolecci&oacute;n y almacenamiento de informaci&oacute;n
                                    </p>

                                    <p style={{ marginTop: 0, marginBottom: '8pt' }}>
                                        SWIFTPAY&reg; podr&aacute; recopilar informaci&oacute;n personal de car&aacute;cter p&uacute;blico o privado, la cual se utilizar&aacute; &uacute;nicamente para los fines indicados en esta pol&iacute;tica.
                                    </p>

                                    <p style={{ marginTop: 0, marginBottom: '8pt', fontWeight: 'bold' }}>
                                        Datos personales p&uacute;blicos:
                                    </p>

                                    <p style={{ marginTop: 0, marginBottom: '8pt' }}>
                                        Aquellos disponibles en bases de datos p&uacute;blicas o de acceso general conforme a la legislaci&oacute;n aplicable, como:
                                    </p>

                                    <ul style={{ margin: 0, paddingLeft: '1.5em' }}>
                                        <li>Nombre completo</li>
                                        <li>N&uacute;mero de c&eacute;dula o pasaporte</li>
                                        <li>Nacionalidad</li>
                                        <li>Sexo</li>
                                        <li>Estado civil</li>
                                    </ul>

                                    <p style={{ marginTop: 0, marginBottom: '8pt', fontWeight: 'bold' }}>
                                        Datos personales privados:
                                    </p>

                                    <ul style={{ margin: 0, paddingLeft: '1.5em' }}>
                                        <li>
                                            <strong>De acceso restringido:</strong> nivel educativo, profesi&oacute;n, datos de contacto, direcci&oacute;n, correo electr&oacute;nico, condici&oacute;n laboral, datos financieros y de facturaci&oacute;n.
                                        </li>
                                        <li>
                                            <strong>Sensibles:</strong> informaci&oacute;n que revele origen &eacute;tnico, estado de salud, o condici&oacute;n socioecon&oacute;mica, solo cuando sea estrictamente necesario para el cumplimiento de obligaciones legales o contractuales.
                                        </li>
                                    </ul>

                                    <p style={{ marginTop: 0, marginBottom: '8pt' }}>&nbsp;</p>

                                    <p style={{ marginTop: 0, marginBottom: '8pt', fontWeight: 'bold' }}>
                                        2. Fuentes de obtenci&oacute;n de la informaci&oacute;n
                                    </p>

                                    <p style={{ marginTop: 0, marginBottom: '8pt' }}>
                                        SWIFTPAY&reg; obtiene informaci&oacute;n personal de las siguientes fuentes:
                                    </p>

                                    <ul style={{ margin: 0, paddingLeft: '1.5em' }}>
                                        <li>Formularios de registro, encuestas o solicitudes en el sitio web o aplicaci&oacute;n.</li>
                                        <li>Transacciones procesadas a trav&eacute;s de la pasarela de pago, POS, Tap on Phone o links de pago de SWIFTPAY&reg;.</li>
                                        <li>Contratos de afiliaci&oacute;n o integraci&oacute;n tecnol&oacute;gica con comercios.</li>
                                        <li>Autorizaciones expresas para almacenar m&eacute;todos de pago tokenizados (tarjetas de cr&eacute;dito o d&eacute;bito).</li>
                                        <li>Programas de lealtad y promociones donde el usuario haya decidido participar.</li>
                                        <li>Correspondencia electr&oacute;nica o comunicaciones con nuestro servicio de soporte.</li>
                                        <li>Informaci&oacute;n de los comercios afiliados al procesar pagos de sus clientes.</li>
                                        <li>Informaci&oacute;n proveniente de terceros autorizados (bancos, marcas de tarjetas, emisores y adquirentes).</li>
                                    </ul>

                                    <p style={{ marginTop: 0, marginBottom: '8pt' }}>&nbsp;</p>

                                    <p style={{ marginTop: 0, marginBottom: '8pt', fontWeight: 'bold' }}>
                                        3. Uso de la informaci&oacute;n recopilada
                                    </p>

                                    <p style={{ marginTop: 0, marginBottom: '8pt' }}>
                                        SWIFTPAY&reg; utilizar&aacute; los datos personales conforme a la <strong>Ley N.&ordm; 8968</strong> y &uacute;nicamente para los siguientes fines leg&iacute;timos:
                                    </p>

                                    <ul style={{ margin: 0, paddingLeft: '1.5em' }}>
                                        <li>Procesar pagos y validar transacciones.</li>
                                        <li>Mitigar riesgos de fraude y suplantaci&oacute;n de identidad.</li>
                                        <li>
                                            Cumplir con normas de <strong>Prevenci&oacute;n de Lavado de Dinero y Financiamiento al Terrorismo</strong>.
                                        </li>
                                        <li>Proporcionar soporte t&eacute;cnico, atenci&oacute;n al cliente y mantenimiento del servicio.</li>
                                        <li>Enviar comprobantes electr&oacute;nicos, notificaciones o recordatorios de pago.</li>
                                        <li>Gestionar la participaci&oacute;n en programas de lealtad o beneficios asociados.</li>
                                        <li>Comunicar promociones, novedades o actualizaciones (siempre con opci&oacute;n de exclusi&oacute;n u &ldquo;OPT OUT&rdquo;).</li>
                                        <li>Cumplir con obligaciones contractuales o regulatorias.</li>
                                        <li>Elaborar estad&iacute;sticas y reportes internos sin identificaci&oacute;n individual del usuario.</li>
                                    </ul>

                                    <p style={{ marginTop: 0, marginBottom: '8pt', fontWeight: 'bold' }}>4. Compromisos de SWIFTPAY&reg; en materia de protecci&oacute;n de datos</p>
                                    <p style={{ marginTop: 0, marginBottom: '8pt' }}>SWIFTPAY&reg; se compromete a:</p>
                                    <ol style={{ margin: 0, paddingLeft: '1.5em' }}>
                                        <li>Notificar al usuario sobre el uso de sus datos personales de manera transparente.</li>
                                        <li>Recopilar &uacute;nicamente los datos estrictamente necesarios para los fines descritos.</li>
                                        <li>Mantener la exactitud, integridad y actualizaci&oacute;n de la informaci&oacute;n.</li>
                                        <li>Implementar medidas t&eacute;cnicas y organizativas de seguridad basadas en est&aacute;ndares internacionales como <strong>PCI DSS</strong>, <strong>ISO 27001</strong> y pr&aacute;cticas de <strong>ciberseguridad bancaria</strong>.</li>
                                        <li>No transferir ni divulgar informaci&oacute;n personal a terceros sin el consentimiento del titular, salvo cuando sea requerido por ley o autoridad competente.</li>
                                        <li>Permitir al usuario ejercer sus derechos de <strong>acceso, rectificaci&oacute;n, cancelaci&oacute;n y oposici&oacute;n (ARCO)</strong> sobre sus datos personales.</li>
                                        <li>Garantizar que cualquier tercero con el cual se compartan datos cumpla con est&aacute;ndares equivalentes de protecci&oacute;n de datos.</li>
                                    </ol>


                                    <p style={{ marginTop: 0, marginBottom: '8pt', fontWeight: 'bold' }}>5. Seguridad de la informaci&oacute;n</p>
                                    <p style={{ marginTop: 0, marginBottom: '8pt' }}>
                                        SWIFTPAY&reg; adopta medidas de seguridad f&iacute;sicas, electr&oacute;nicas y administrativas para proteger los datos personales contra p&eacute;rdida, uso indebido, acceso no autorizado o divulgaci&oacute;n. Entre ellas se incluyen:
                                    </p>
                                    <ul style={{ margin: 0, paddingLeft: '1.5em' }}>
                                        <li>Encriptaci&oacute;n de datos y tokenizaci&oacute;n de medios de pago.</li>
                                        <li>Autenticaci&oacute;n multifactor para accesos administrativos.</li>
                                        <li>Monitoreo 24/7 y auditor&iacute;as de seguridad.</li>
                                        <li>Segmentaci&oacute;n de redes conforme a <strong>PCI DSS</strong>.</li>
                                        <li>Pol&iacute;ticas internas de confidencialidad y acceso restringido al personal autorizado.</li>
                                    </ul>


                                    <p style={{ marginTop: 0, marginBottom: '8pt', fontWeight: 'bold' }}>6. Enlaces a terceros</p>
                                    <p style={{ marginTop: 0, marginBottom: '8pt' }}>
                                        El sitio web o aplicaci&oacute;n de SWIFTPAY&reg; puede contener enlaces a p&aacute;ginas o servicios de terceros. Al acceder a dichos enlaces, SWIFTPAY&reg; no asume responsabilidad por las pr&aacute;cticas de privacidad o contenido de esos sitios. Se recomienda al usuario revisar las pol&iacute;ticas de privacidad de dichos terceros antes de proporcionar informaci&oacute;n personal.
                                    </p>


                                    <p style={{ marginTop: 0, marginBottom: '8pt', fontWeight: 'bold' }}>7. Conducta responsable del usuario</p>
                                    <p style={{ marginTop: 0, marginBottom: '8pt' }}>
                                        El usuario garantiza que los datos proporcionados a SWIFTPAY&reg; son <strong>veraces, completos y actualizados</strong>, y se compromete a notificar cualquier modificaci&oacute;n. SWIFTPAY&reg; <strong>no vender&aacute;, ceder&aacute; ni distribuir&aacute; informaci&oacute;n personal sin consentimiento</strong>, salvo en los casos autorizados por la Ley N.&ordm; 8968 y su reglamento.
                                    </p>


                                    <p style={{ marginTop: 0, marginBottom: '8pt', fontWeight: 'bold' }}>8. Ejercicio de derechos ARCO</p>
                                    <p style={{ marginTop: 0, marginBottom: '8pt' }}>
                                        Los usuarios podr&aacute;n ejercer sus derechos de <strong>acceso, rectificaci&oacute;n, oposici&oacute;n o cancelaci&oacute;n</strong> del tratamiento de sus datos personales, enviando una solicitud al correo electr&oacute;nico: <strong>afiliacion@swiftpay.one</strong>.
                                    </p>
                                    <p style={{ marginTop: 0, marginBottom: '8pt' }}>
                                        La solicitud deber&aacute; incluir el nombre completo, copia de un documento de identidad y la descripci&oacute;n clara de la acci&oacute;n solicitada. SWIFTPAY&reg; responder&aacute; conforme a los plazos establecidos por la normativa vigente.
                                    </p>


                                    <p style={{ marginTop: 0, marginBottom: '8pt', fontWeight: 'bold' }}>9. Modificaciones a la Pol&iacute;tica de Privacidad</p>
                                    <p style={{ marginTop: 0, marginBottom: '8pt' }}>
                                        SWIFTPAY&reg; se reserva el derecho de modificar esta Pol&iacute;tica de Privacidad en cualquier momento, con el fin de adaptarla a cambios legislativos, regulatorios o tecnol&oacute;gicos. Cualquier modificaci&oacute;n ser&aacute; publicada en los canales oficiales de SWIFTPAY&reg; y comunicada oportunamente a los usuarios.
                                    </p>
                                    <p style={{ marginTop: '10%', marginBottom: '8%', textAlign: 'center' }}>
                                        <strong>Autorizada en San Jos&eacute;, Costa Rica &ndash; Octubre 2025.</strong><br />&copy; 2025 SWIFTPAY S.A. &ndash; Todos los derechos reservados.
                                    </p>
                                </div>
                            </div>

                        </div>

                    )
            }

        </div>



    );
};




export default PolicityPage;
